import { useTranslation } from 'react-i18next';
import { ErrorFallback } from './ErrorFallback';
import { FallbackProps } from 'react-error-boundary';
import { ErrorCodes } from 'src/common/responseCodes';

export const SomethingWentWrongErrorFallback = ({ error }: FallbackProps) => {
  const { t } = useTranslation();

  if (error.message === ErrorCodes.AccessDenied) {
    return null;
  }

  return (
    <ErrorFallback
      message={
        error.message === ErrorCodes.NotFound ? t('common.pageNotFound') : t('auth.somethingWrong')
      }
    />
  );
};
